<template>
  <form method="post" @submit.prevent="onSend" novalidate>
    <form-wrapper :validator="$v.form">
      <div class="columns">
        <div class="column">
          <form-group
            name="remark"
            :label="$t('attributes.gift_application_remark')"
            label-position="on-border"
          >
            <b-input
              v-model="form.remark"
              type="textarea"
              name="remark"
              maxlength="500"
              placeholder="詳述買回明細與原因"
              expanded
            ></b-input>
          </form-group>
          <div class="buttons is-right">
            <b-button
              :loading="sending"
              style="width: 100px"
              @click="onCancel"
              tabindex="10"
            >
              {{ $t('attributes.cancel') }}
            </b-button>
            <b-button
              :loading="sending"
              type="is-primary"
              native-type="submit"
              style="width: 100px"
              tabindex="10"
            >
              {{ $t('attributes.add') }}
            </b-button>
          </div>
          <div>
            <h3>贈品列表</h3>
            <b-table
              :data="filterGifts"
              :loading="loadingGifts"
              :mobile-cards="false"
              width="600"
              narrowed
              sticky-header
              height="calc(100vh - 302px)"
            >
              <b-table-column
                field="id"
                :visible="false"
                :label="$t('attributes.id')"
                width="75"
                centered
                v-slot="props"
              >
                {{ props.row.id }}
              </b-table-column>
              <b-table-column
                field="picture"
                :label="$t('attributes.picture')"
                width="60"
                centered
                header-class="nowrap"
                v-slot="props"
              >
                <figure v-if="props.row.picture" class="image">
                  <a
                    :href="GiftImage(props.row.picture)"
                    title="贈品圖片"
                    @click.prevent="onClickImage(props.row)"
                  >
                    <img
                      :src="GiftImage(props.row.picture)"
                      :alt="$t('attributes.picture')"
                      style="width: 80px; margin: auto;"
                    />
                  </a>
                </figure>
                <p v-else class="has-text-danger has-text-weight-medium">無</p>
              </b-table-column>
              <b-table-column
                field="name"
                :label="$t('attributes.name')"
                header-class="nowrap"
                v-slot="props"
              >
                <span>{{ props.row.full_name }}</span>
              </b-table-column>
              <b-table-column
                field="net_price"
                :label="$t('attributes.gift_net_price')"
                width="80"
                centered
                numeric
                header-class="nowrap"
                v-slot="props"
              >
                <span :class="{ 'is-strike': isFree(props.row) }">
                  {{ props.row.net_price }}
                </span>
              </b-table-column>
              <b-table-column
                field="sales_price"
                :label="$t('attributes.gift_repurchase_price')"
                width="120"
                numeric
                centered
                header-class="nowrap"
                v-slot="props"
              >
                <b-input
                  v-model.number="props.row.sales_price"
                  name="sales_price"
                  type="number"
                  min="0"
                  rounded
                  :disabled="!props.row.can_apply"
                  :placeholder="
                    $t('message.please_input') +
                      $t('attributes.gift_repurchase_price')
                  "
                ></b-input>
              </b-table-column>
              <b-table-column
                field="quantity"
                :label="$t('attributes.gift_current_quantity')"
                width="80"
                centered
                numeric
                header-class="nowrap"
                v-slot="props"
              >
                {{ props.row.quantity }}
              </b-table-column>
              <b-table-column
                field="application_quantity"
                :label="$t('attributes.gift_application_repurchase_quantity')"
                width="120"
                centered
                header-class="nowrap"
                v-slot="props"
              >
                <b-input
                  v-model.number="props.row.apply_quantity"
                  name="quantity"
                  type="number"
                  min="0"
                  :max="props.row.quantity"
                  rounded
                  :disabled="!props.row.can_apply"
                  :placeholder="
                    $t('message.please_input') +
                      $t('attributes.gift_application_repurchase_quantity')
                  "
                ></b-input>
              </b-table-column>
              <b-table-column
                field="amount"
                :label="$t('attributes.gift_amount')"
                width="80"
                numeric
                header-class="nowrap"
                v-slot="props"
              >
                <span
                  v-if="props.row.can_apply"
                  class="has-text-danger has-text-weight-bold"
                >
                  {{ formatCurrency(calculateAmount(props.row)) }}
                </span>
                <span v-else class="has-text-danger has-text-weight-bold">
                  未過帳
                </span>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
    </form-wrapper>
    <b-modal has-modal-card :active.sync="isImageModalActive">
      <p class="image">
        <img
          style="max-width: 450px; max-height: 800px; text-align: center;"
          :src="GiftImage(showPicture)"
          alt=""
        />
      </p>
    </b-modal>

    <b-loading
      :active.sync="isLoading"
      :is-full-page="false"
      :can-cancel="false"
    ></b-loading>
  </form>
</template>
<script>
import { GIFTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { maxLength, required } from 'vuelidate/lib/validators'
export default {
  name: 'ApplicationRepurchaseForm',

  props: {
    sales_code: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      sending: false,
      isLoading: false,
      loadingGifts: false,
      gifts: [],
      giftFilter: null,

      form: this.extractForm(this.application),

      isImageModalActive: false,
      showPicture: null
    }
  },
  validations() {
    return {
      form: {
        gifts: { required },
        remark: { required, maxLength: maxLength(500) }
      }
    }
  },
  computed: {
    filterGifts() {
      let gifts = this.gifts.slice()

      if (this.giftFilter) {
        gifts = gifts.filter(g => g.full_name.includes(this.giftFilter))
      }
      return gifts
    }
  },
  mounted() {
    this.loadGiftsAsync()
  },
  methods: {
    extractForm() {
      return {
        sales_code: this.sales_code,
        gifts: [],
        amount: null,
        remark: null
      }
    },
    async loadGiftsAsync() {
      try {
        const api = `${GIFTS_API}/list-apply`
        const params = {
          search: null
        }
        this.loadingGifts = true
        const res = await this.axios.get(api, { params })
        this.gifts = res.data.data.map(gift => {
          const apply_quantity = gift.apply_quantity ? gift.apply_quantity : 0
          const repurchase_price = gift.net_price ? gift.net_price : 0
          return {
            ...gift,
            can_apply: gift.posts.length > 0,
            apply_quantity: apply_quantity,
            sales_price: repurchase_price
          }
        })
      } catch (e) {
        this.gifts = []
        notifyService.fetch_error('gift', e)
      } finally {
        this.loadingGifts = false
      }
    },
    isFree(gift) {
      return this.form.is_public || gift.department_no === this.sales_department
    },
    calculateAmount(gift) {
      return gift.sales_price * gift.apply_quantity
    },
    calculateTotalAmount() {
      return this.gifts.reduce(
        (sum, gift) => sum + this.calculateAmount(gift),
        0
      )
    },
    onClickImage(gift) {
      this.showPicture = gift.picture
      this.isImageModalActive = true
    },
    onCancel() {
      this.$emit('cancel')
    },
    onSend() {
      let auth_result = this.gifts.filter(g => g.apply_quantity < 0)
      if (auth_result.length > 0) {
        return notifyService.error('買回數量不可小於 0')
      }

      this.form.gifts = this.gifts.filter(g => g.apply_quantity > 0)
      if (this.form.gifts === null || this.form.gifts.length <= 0) {
        return notifyService.error('贈品買回失敗，至少有一項買回的贈品')
      }

      auth_result = this.form.gifts.filter(
        g => g.sales_price < 0 || g.sales_price === null
      )
      if (auth_result.length > 0) {
        return notifyService.error('買回價格不能小於 0 或空白')
      }
      this.form.amount = this.calculateTotalAmount()

      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      this.$emit('send', this.form)
    }
  }
}
</script>
